import * as z from "zod";

export const automateShippingClaim = {
  name: "automateShippingClaim" as const,
  input: z.object({ claimIds: z.array(z.string()) }),
  output: z.object({ success: z.boolean(), message: z.string() }),
};
